export default Object.freeze({
  BRIGHTNESS_OFFSET: 'BRIGHTNESS_OFFSET'
});